module.exports = __webpack_public_path__ + "media/img/kim-fax-chat-03acb96659cab2ee87798f19681fa6f7.png";